// extracted by mini-css-extract-plugin
module.exports = {"main":"AppFoLayout_main__PwkKD"};